import { Route } from 'react-router-dom';
import Mora from './Mora';
import ListarMoraComponente from './Listar-Mora';
import ListarCreditosLegalComponente from './Listar-Legal';

const MoraRouter = (
  <Route path="mora" element={<Mora />}>
    <Route path="cliente" element={<ListarMoraComponente />} />
    <Route path="legal" element={<ListarCreditosLegalComponente />} />
  </Route>
);

export default MoraRouter;
